export default __webpack_public_path__ + "23f2c1a5771b28cde602ec45dd72ba74.svg";